import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import * as cafeActions from '../../../redux/cafes/actions';
import ENUMS from '../../../enums';

const CafeDiscountRequestsFilter = props => {
  let { onSelectCafeIds, pageNumber } = props;

  let formRefrence = useRef();
  let [cafeIds, setCafeIds] = useState([]);
  let [selectedStatusCheckbox, setSelectedStatusCheckbox] = useState([]);

  useEffect(() => {
    props.getAllCafeNamesForPanel();
  }, []);

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setCafeIds([]);
    onSelectCafeIds([]);
    setSelectedStatusCheckbox(null);
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => {
          props.applyFilters(event);
        }}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex col-12 justidy-content-between px-1">
            <Select
              id="cafeIds"
              name="cafeIds"
              isMulti={true}
              value={cafeIds}
              onChange={selectedCafeIds => {
                setCafeIds(selectedCafeIds);
                onSelectCafeIds(selectedCafeIds);
              }}
              className="col-9 mx-1"
              options={props.cafeNamesList.map(n => ({
                label: n.name,
                value: n.id
              }))}
              placeholder={locales('fields.cafe.name')}
            />
          </div>
          <div className="d-flex col-12 justify-content-between mx-1 py-2">
            <span className="col-2 text-center d-flex align-items-center">
              {locales('tables.status')} :{' '}
            </span>
            <div className="col-10 d-flex justify-content-between align-items-center">
              {ENUMS.CAFE_DISCOUNT_STATUS.list.map((bankStatus, index) => (
                <div className={`col-4 d-flex p-0`} key={index}>
                  <input
                    type="checkbox"
                    value={bankStatus.value}
                    name={`status`}
                    id={`status-${index}`}
                    className="my-2"
                  />
                  <label className="my-2 mx-1" htmlFor={`status-${index}`}>
                    {bankStatus.title}
                  </label>
                </div>
              ))}
            </div>
            {/* <Checkbox.Group
                value={selectedStatusCheckbox}
                onChange={selectedIds => setSelectedStatusCheckbox(selectedIds)}
                name="status"
                id="status"
                options={ENUMS.BANK_STATUS.list.map(bankStatus => ({
                  label: bankStatus.title,
                  value: bankStatus.value
                }))}
              /> */}
          </div>
          <div className="col-12 d-flex justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button
              type="submit"
              id="apply-filter-btn-cafeDiscountRequests"
              className="btn btn-success w-5 mx-2"
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

const mapStateToProps = state => {
  return {
    cafeNamesLoading: state.cafesReducer.cafeNamesLoading,
    cafeNames: state.cafesReducer.cafeNames,
    cafeNamesFailed: state.cafesReducer.cafeNamesFailed,
    cafeNamesMessage: state.cafesReducer.cafeNamesMessage,
    cafeNamesError: state.cafesReducer.cafeNamesError,
    
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNamesListLoading: state.cafesReducer.cafeNamesListLoading,
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNamesListFailed: state.cafesReducer.cafeNamesListFailed,
    cafeNamesListMessage: state.cafesReducer.cafeNamesListMessage,
    cafeNamesListError: state.cafesReducer.cafeNamesListError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAllCafeNamesForPanel: () => dispatch(cafeActions.getAllCafeNamesForPanel())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CafeDiscountRequestsFilter);
